module.exports = __webpack_public_path__ + "img/HN.d7d6e3a9.png";